import { getApiBaseUrl } from "@/config/runtime";
import type { ExportCapabilities } from "@/types";
import { api, getHeaders } from "../api";

export const exportService = {
  exportSession: async (
    sessionId: string,
    options: { format: string; template: string; content: string; includeSystemMessages: boolean },
  ): Promise<Blob> => {
    const headers = await getHeaders();
    const response = await fetch(`${getApiBaseUrl()}/chat/sessions/${sessionId}/export`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        format: options.format,
        template: options.template,
        content: options.content,
        include_system_messages: options.includeSystemMessages,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Export failed: ${errorText || response.statusText}`);
    }

    return response.blob();
  },

  getCapabilities: () => api.get<ExportCapabilities>("/export/capabilities"),
};
